import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';

import { NgForm } from "@angular/forms"
import { ActivatedRoute, Router } from '@angular/router';
import { AngularStripeService } from '@fireflysemantics/angular-stripe-service'
import { MessageService } from 'primeng/api';
import { UtilityService } from 'src/app/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-page',
  templateUrl: './payment-page.component.html',
  styleUrls: ['./payment-page.component.less']
})
export class PaymentPageComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild('cardInfo', { static: false })
  cardInfo!: ElementRef;
  stripe: any;
  loading = false;
  confirmation: any;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string = '';
  paymentData: any;

  constructor(
    private cd: ChangeDetectorRef,
    private stripeService: AngularStripeService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _dataService: CommonDataService,
    private _utilityService: UtilityService,
    private _messageService: MessageService,) { }
  ngOnInit(): void {
    this._route.params.subscribe(params => {
      this.paymentData = (params && params.paymentData) ? JSON.parse(atob(params.paymentData)) : undefined;
      console.log(this.paymentData);
    });
  }
  ngAfterViewInit() {
    let stripeKey;
    if (window.location.host.includes('app.iylon.com')) {
      stripeKey = environment.prod_stripe_key;
      this.paymentData['isProd'] = true;
    } else {
      alert('We have noticed you are in test mode. Please use below credit card detials.\nCard Number: 4242 4242 4242 4242\nExpiry Date: Any future date\nCVV: Any 3 digit number\nName: Your name\nPostal Code: 12345\n');
      stripeKey = environment.test_stripe_key;
      this.paymentData['isProd'] = false;
    }
    this.stripeService.setPublishableKey(stripeKey).then(
      stripe => {
        this.stripe = stripe;
        const elements = stripe.elements();
        this.card = elements.create('card');
        this.card.mount(this.cardInfo.nativeElement);
        this.card.addEventListener('change', this.cardHandler);
      });
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }: any) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = '';
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {
    this._dataService.isLoading = true;
    let router=this._router;
    let messageService=this._messageService;
    let utilityService=this._utilityService;
    this.stripe.confirmCardPayment(
      this.paymentData.stripeData.client_secret,
      {
        payment_method: { card: this.card }
      }
    ).then(function (result: any) {
      if (result.error) {
        console.log(result.error);
        utilityService.showErrorWithCross("Payment Failed");
      } else {
        messageService.add({ severity: 'success', summary: 'Payment', detail: 'Payment Successfully.' });
        router.navigate(["/landing/activeCase"]);
        // The payment has succeeded
        // Display a success message
      }
    });
  }
}
